import React from 'react'
import { BeatLoader } from  'react-spinners'

export default function Loader({ color, smallLoader=false }) {
    return (
        <BeatLoader color={color?color:"#ffff"} size={`${smallLoader ? '7px' : "10px"}`} />

    )
}
